import { getLastSortedColumnValue, getLastRFQColumnId,
  getLastRFQDetailsColumnId } from '../utils/pagination';
import {
  FILTER_FINALISE_BID_ENABLE_LOADING,
  FILTER_FINALISE_BID_DISABLE_LOADING,
  RFQ_FETCH_ENABLE_LOADING,
  RFQ_FINALISE_BID_DISABLE_LOADING,
  RFQ_FINALISE_BID_ENABLE_LOADING,
  RFQ_CREATE_ENABLE_LOADING,
  RFQ_FETCH_DISABLE_LOADING,
  RFQ_DETAILS_ENABLE_LOADING,
  RFQ_UPDATE_STATUS_ENABLE_LOADING,
  RFQ_DETAILS_ALL_DATA_LOADED,
  RFQ_DETAILS_LOADED,
  RFQ_CREATE_DISABLE_LOADING,
  RFQ_DETAILS_DISABLE_LOADING,
  RFQ_FETCH_ERROR,
  RFQ_FETCH_LOADED,
  RFQ_RESET_PAGINATION,
  RFQ_UPDATE_FILTERS,
  RFQ_RESET_FILTERS,
  RFQ_EDIT_REFERENCE_RATE_ENABLE_LOADING,
  RFQ_EDIT_STATUS_ENABLE_LOADING,
  RFQ_EDIT_STATUS_DISABLE_LOADING,
  RFQ_EDIT_REFERENCE_RATE_DISABLE_LOADING,
  RFQ_SET_PAGINATION,
  RFQ_DETAILS_ERROR,
  RFQ_SEND_ENABLE_LOADING,
  RFQ_DETAIL_BID_ENABLE_LOADING,
  RFQ_DETAIL_BID_DISABLE_LOADING,
  RFQ_DETAIL_BID_DATA,
  RFQ_DETAIL_BID_ERROR,
  RFQ_SEND_DISABLE_LOADING,
  RFQ_SET_PERMISSABLE_PORTS,
  RFQ_SET_DESTINATION_PORTS,
  RFQ_SELECT_BID_LINE_ITEM_ENABLE_LOADING,
  RFQ_SELECT_BID_LINE_ITEM_DISABLE_LOADING,
  RFQ_BID_DETAILS_ENABLE_LOADING,
  RFQ_BID_DETAILS_DISABLE_LOADING,
  RFQ_BID_DETAILS_LOADED,
  RFQ_BID_DETAILS_ERROR,
  RFQ_UPDATE_STATUS_DISABLE_LOADING,
  RFQ_DETAIL_UPDATE_FILTER,
  RFQ_DESTINATION_PORTS_DISABLE_LOADING,
  RFQ_DESTINATION_PORTS_ENABLE_LOADING,
  RFQ_PERMISSABLE_PORTS_DISABLE_LOADING,
  RFQ_PERMISSABLE_PORTS_ENABLE_LOADING,
  RFQ_LINE_ITEM_ACTIVITY_ENABLE_LOADING,
  RFQ_LINE_ITEM_ACTIVITY_DISABLE_LOADING,
  RFQ_LINE_ITEM_ACTIVITY_LOADED,
  RFQ_BID_ACTIVITY_ENABLE_LOADING,
  RFQ_BID_ACTIVITY_DISABLE_LOADING,
  RFQ_ADD_LINE_ITEM_DISABLE_LOADING,
  RFQ_ADD_LINE_ITEM_ENABLE_LOADING,
  RFQ_BID_ACTIVITY_LOADED,
  RFQ_BID_LIST_UPDATE_FILTER,
  RFQ_BID_DOWNLOADED,
  RFQ_BID_DOWNLOAD_ENABLE_LOADING,
  RFQ_BID_DOWNLOAD_DISABLE_LOADING,
  RFQ_BID_COMPARISON_DISABLE_LOADING,
  RFQ_BID_COMPARISON_ENABLE_LOADING,
  RFQ_BID_COMPARISON_LOADED,
  REPLACE_PREV_PAGINATION,
  RFQ_RESET_BID_LIST_FILTERS,
  RFQ_BID_RESET_BID_DATA,
  DETAILS_SET_PAGINATION,
  DETAILS_RESET_PAGINATION,
} from '../actions/constants';
import { RFQPlanStatus } from 'src/components/pages/RFQ/RFQPlanDetails/RFQPlanDetail.types';
const defaultState = {
  isLoading: true,
  errorMessage: null,
  rfqList: null,
  selectedBidListFilters: {
    sortBy: 'updatedAt',
  },
  selectedDetailFilters: {
    statuses: [] as RFQPlanStatus[],
    originPortIds: [],
    destinationPortIds: [],
    shippingLineIds: [],
    bidsOrderedByFilter: 'chargeForRanking',
    viewType: 'NON-FINALISED',
    rfqPlanId: null,
    amendmentVersions: [],
    containerSizeList: [],
    incoterms: [],
    chargeTypeList: [],
    conditonTypeList: [],
    ffShippingLineList: [],
    supplierList: [],
    sortBy: 'updatedAt',
    startDate: '',
    endDate: '',
  },
  selectedFilters: {
    statuses: undefined,
    periods: [],
    rfqTypes: [],
    rfqSubTypes: [],
    rfqModes: [],
    searchQuery: '',
  },
  pagination: {
    currentPageNumber:1,
    nextOrPrev:'first',
    isNextPresent: true,
    batchSize: 10,
  },
  detailsPagination: {
    currentPageNumber: 1,
    nextOrPrev: 'first',
    isNextPresent: true,
    resultPerPage: 100,
  },
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case FILTER_FINALISE_BID_DISABLE_LOADING: {
      return {
        ...state,
        isFilterFinaliseBidLoading: false,
      };
    }
    case FILTER_FINALISE_BID_ENABLE_LOADING: {
      return {
        ...state,
        isFilterFinaliseBidLoading: true,
      };
    }
    case RFQ_ADD_LINE_ITEM_ENABLE_LOADING: {
      return {
        ...state,
        isAddLineItemLoading: true,
      };
    }
    case RFQ_ADD_LINE_ITEM_DISABLE_LOADING: {
      return {
        ...state,
        isAddLineItemLoading: false,
      };
    }
    case RFQ_BID_COMPARISON_ENABLE_LOADING: {
      return {
        ...state,
        isBidComparisonLoading: true,
      };
    }
    case RFQ_BID_COMPARISON_DISABLE_LOADING: {
      return {
        ...state,
        isBidComparisonLoading: false,
      };
    }
    case RFQ_BID_COMPARISON_LOADED: {
      return {
        ...state,
        bidComparisonData: action.data,
      };
    }
    case RFQ_FINALISE_BID_ENABLE_LOADING: {
      return {
        ...state,
        isBidFinaliseLoading: true,
      };
    }
    case RFQ_FINALISE_BID_DISABLE_LOADING: {
      return {
        ...state,
        isBidFinaliseLoading: false,
      };
    }
    case RFQ_LINE_ITEM_ACTIVITY_ENABLE_LOADING: {
      return {
        ...state,
        isLineItemActivityLoading: true,
      };
    }
    case RFQ_LINE_ITEM_ACTIVITY_DISABLE_LOADING: {
      return {
        ...state,
        isLineItemActivityLoading: false,
      };
    }
    case RFQ_LINE_ITEM_ACTIVITY_LOADED: {
      return {
        ...state,
        lineItemActivityData: action.data,
      };
    }
    case RFQ_BID_ACTIVITY_ENABLE_LOADING: {
      return {
        ...state,
        isBidActivityLoading: true,
      };
    }
    case RFQ_BID_ACTIVITY_DISABLE_LOADING: {
      return {
        ...state,
        isBidActivityLoading: false,
      };
    }
    case RFQ_BID_ACTIVITY_LOADED: {
      return {
        ...state,
        bidActivityData: action.data,
      };
    }
    case RFQ_BID_DOWNLOAD_ENABLE_LOADING: {
      return {
        ...state,
        isBidDownloadLoading: true,
      };
    }
    case RFQ_BID_DOWNLOAD_DISABLE_LOADING: {
      return {
        ...state,
        isBidDownloadLoading: false,
      };
    }
    case RFQ_BID_DOWNLOADED: {
      return {
        ...state,
        downloadData: action.data,
      };
    }
    case RFQ_DETAIL_UPDATE_FILTER: {
      return {
        ...state,
        selectedDetailFilters: Object.assign({}, state.selectedDetailFilters, action.data),
      };
    }
    case RFQ_UPDATE_STATUS_ENABLE_LOADING: {
      return {
        ...state,
        isRFQStatusLoading: true,
      };
    }
    case RFQ_UPDATE_STATUS_DISABLE_LOADING: {
      return {
        ...state,
        isRFQStatusLoading: false,
      };
    }
    case RFQ_DESTINATION_PORTS_ENABLE_LOADING: {
      return {
        ...state,
        isDestinationPortsLoading: true,
      };
    }
    case RFQ_DESTINATION_PORTS_DISABLE_LOADING: {
      return {
        ...state,
        isDestinationPortsLoading: false,
      };
    }
    case RFQ_PERMISSABLE_PORTS_ENABLE_LOADING: {
      return {
        ...state,
        isPermissablePortsLoading: true,
      };
    }
    case RFQ_PERMISSABLE_PORTS_DISABLE_LOADING: {
      return {
        ...state,
        isPermissablePortsLoading: false,
      };
    }
    case RFQ_BID_DETAILS_ENABLE_LOADING: {
      return {
        ...state,
        isBidDetailsLoading: true,
      };
    }
    case RFQ_BID_DETAILS_DISABLE_LOADING: {
      return {
        ...state,
        isBidDetailsLoading: false,
      };
    }
    case RFQ_BID_DETAILS_LOADED: {
      return {
        ...state,
        bidDetailData: action.data,
        bidDetailError: null,
      };
    }
    case RFQ_BID_DETAILS_ERROR: {
      return {
        ...state,
        bidDetailError: action.errorMessage,
        bidDetailData: null,
      };
    }
    case RFQ_SELECT_BID_LINE_ITEM_ENABLE_LOADING: {
      return {
        ...state,
        isBidLineItemLoading: true,
      };
    }
    case RFQ_SELECT_BID_LINE_ITEM_DISABLE_LOADING: {
      return {
        ...state,
        isBidLineItemLoading: false,
      };
    }
    case RFQ_SEND_ENABLE_LOADING: {
      return {
        ...state,
        isSendRFQLoading: true,
      };
    }
    case RFQ_SEND_DISABLE_LOADING: {
      return {
        ...state,
        isSendRFQLoading: false,
      };
    }
    case RFQ_EDIT_STATUS_ENABLE_LOADING: {
      return {
        ...state,
        isEditStatusLoading: true,
      };
    }
    case RFQ_EDIT_STATUS_DISABLE_LOADING: {
      return {
        ...state,
        isEditStatusLoading: false,
      };
    }
    case RFQ_EDIT_REFERENCE_RATE_ENABLE_LOADING: {
      return {
        ...state,
        isEditReferenceRateLoading: true,
      };
    }
    case RFQ_EDIT_REFERENCE_RATE_DISABLE_LOADING: {
      return {
        ...state,
        isEditReferenceRateLoading: false,
      };
    }
    case RFQ_BID_LIST_UPDATE_FILTER: {
      return {
        ...state,
        selectedBidListFilters: Object.assign({}, state.selectedBidListFilters, action.data),
      };
    }
    case RFQ_RESET_BID_LIST_FILTERS: {
      return {
        ...state,
        selectedBidListFilters: { ...defaultState.selectedBidListFilters },
      };
    }
    case RFQ_DETAILS_ENABLE_LOADING: {
      return {
        ...state,
        isDetailsLoading: true,
        detailsData: action.clearData ? {} : state.detailsData,
      };
    }
    case RFQ_DETAILS_DISABLE_LOADING: {
      return {
        ...state,
        isDetailsLoading: false,
      };
    }
    case RFQ_DETAILS_ALL_DATA_LOADED: {
      return {
        ...state,
        allDetailsData: action.data,
      };
    }
    case RFQ_DETAILS_LOADED: {
      return {
        ...state,
        detailsData: action.data,
        selectedDetailFilters: {
          ...state.selectedDetailFilters,
          viewType: action.data.viewType,
        },
        detailsPagination: {
          ...state.detailsPagination,
          currentPageNumber: action.data.currentPageNumber ||
          state.detailsPagination.currentPageNumber,
          isNextPresent: action.data.isNextPresent,
          lastSortedColumnValueNext: action.data.lastSortedColumnValueNext,
          lastItemIdNext: action.data.lastItemIdNext,
          lastSortedColumnValuePrev: action.data.lastSortedColumnValuePrev,
          lastItemIdPrev: action.data.lastItemIdPrev,
          lastSortedColumnValue: getLastSortedColumnValue(action.data),
          lastRowId: getLastRFQDetailsColumnId(action.data),
        },
        detailsError: null,
      };
    }
    case DETAILS_SET_PAGINATION: {
      return {
        ...state,
        detailsPagination: {
          ...state.detailsPagination,
          ...action.data,
        },
      };
    }

    case DETAILS_RESET_PAGINATION: {
      return {
        ...state,
        detailsPagination: {
          ...defaultState.detailsPagination,
          resultPerPage: state.detailsPagination.resultPerPage,
        },
      };
    }
    case RFQ_DETAILS_ERROR: {
      return {
        ...state,
        detailsData: null,
        detailsError: action.errorMessage,
      };
    }
    case RFQ_CREATE_ENABLE_LOADING: {
      return {
        ...state,
        isCreateLoading: true,
      };
    }
    case RFQ_CREATE_DISABLE_LOADING: {
      return {
        ...state,
        isCreateLoading: false,
      };
    }
    case RFQ_FETCH_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case RFQ_FETCH_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case RFQ_FETCH_LOADED: {
      return {
        ...state,
        rfqList: action.data.data,
        errorMessage: null,
        pagination: {
          ...state.pagination,
          currentPageNumber: action.data.currentPageNumber,
          isNextPresent: action.data.isNextPresent,
          lastSortedColumnValueNext: action.data.lastSortedColumnValueNext,
          lastItemIdNext: action.data.lastItemIdNext,
          lastSortedColumnValuePrev: action.data.lastSortedColumnValuePrev,
          lastItemIdPrev: action.data.lastItemIdPrev,
          lastSortedColumnValue: getLastSortedColumnValue(action.data),
          lastRowId: getLastRFQColumnId(action.data),
        },
      };
    }
    case RFQ_SET_PERMISSABLE_PORTS: {
      return {
        ...state,
        rfqPermissablePorts: action.data,
      };
    }
    case RFQ_SET_DESTINATION_PORTS: {
      return {
        ...state,
        rfqDestinationPorts: action.data,
      };
    }
    case RFQ_FETCH_ERROR: {
      return {
        ...state,
        rfqList: null,
        errorMessage: action.errorMessage,
      };
    }
    case RFQ_RESET_FILTERS: {
      return {
        ...state,
        selectedFilters: defaultState.selectedFilters,
        pagination: defaultState.pagination,
      };
    }
    case RFQ_RESET_PAGINATION: {
      return {
        ...state,
        pagination: defaultState.pagination,
        prevPagination: defaultState.pagination,
      };
    }
    case REPLACE_PREV_PAGINATION: {
      return {
        ...state,
        pagination: state.prevPagination ?
        { ...state.prevPagination } : defaultState.pagination,
      };
    }
    case RFQ_UPDATE_FILTERS: {
      return {
        ...state,
        selectedFilters: Object.assign({}, state.selectedFilters, action.data),
      };
    }
    case RFQ_SET_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
        prevPagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    case RFQ_DETAIL_BID_ENABLE_LOADING: {
      return {
        ...state,
        isBidDetailLoading: true,
      };
    }
    case RFQ_DETAIL_BID_DISABLE_LOADING: {
      return {
        ...state,
        isBidDetailLoading: false,
      };
    }
    case RFQ_DETAIL_BID_DATA: {
      return {
        ...state,
        bidData: action.data,
        bidError: null,
      };
    }
    case RFQ_DETAIL_BID_ERROR: {
      return {
        ...state,
        bidError: action.errorMessage,
        bidData: null,
      };
    }
    case RFQ_BID_RESET_BID_DATA: {
      return {
        ...state,
        bidData: null,
      };
    }
    default: {
      return state;
    }
  }
}
